export default __webpack_public_path__ + "static/priority_Low.44650a99756024a839c8f8eee33cf1f4.svg";